import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AccessDeniedPage } from './pages/access-denied';
import { ConsolePage } from './pages/console';
import { LandingPage } from './pages/landing';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<ConsolePage />} />
        <Route path="/access-denied" element={<AccessDeniedPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}
